<div class="row-panel" #innerRowPanelContainer [id]="elementId">
    <ng-template dynamicComponent></ng-template>
</div>
